import type { MarketplaceMultipleApnHelpAndFaq } from './MarketplaceMultipleApn.types'

export const MarketplaceMultipleApnHelpAndFaqData: MarketplaceMultipleApnHelpAndFaq =
  {
    marketPlace: {
      content: [],
    },
    coSell: {
      content: [],
    },
  }
